<!--
 Created by 2021-12-17 14:05:33
 饼图
-->
<template>
  <div :id="id" :style="echarStyle"></div>
</template>
<script>
import * as echarts from "echarts";
import Vue from "vue";
Vue.prototype.$echarts = echarts;
export default {
  name: "echar",
  props: {
    id: {
      type: String,
    },
    echarStyle: {},
  },
  data() {
    return {
      myChart: null,
    };
  },
  mounted() {
    this.drawLine();
    window.addEventListener("resize", this.resize());
  },
  created() {
    const user = this.$ls.get("user");
  },
  beforeDestroy() {
    // 移除事件监听，防止内存泄漏
    window.removeEventListener("resize", this.resize());
  },
  methods: {
    //自适应宽度
    resize() {
      let that = this;
      let timer = null;
      return function () {
        if (timer) {
          clearTimeout(timer);
        }
        timer = setTimeout(() => {
          // 检查图表实例是否存在
          if (that.myChart) {
            that.myChart.resize();
          }
        });
      };
    },
    refreshData(xAxisData, seriesData,title,label) {
      var option = this.myChart.getOption();
      option.series[0].data = seriesData;
      option.title[0].text = title;
      if (label && typeof label === 'object'){
        option.label = {...label};
      }
      this.myChart.setOption(option);
      this.myChart.resize();
    },
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      this.myChart = echarts.init(document.getElementById(this.id));
      // 绘制图表
      this.myChart.setOption({
        // 标题配置
        title: {
          text: '', // 标题文本，空字符串表示不显示标题
          show: false // 不显示标题（因为卡片已有标题）
        },
        // 标签配置（饼图上的文字说明）
        label: {
          alignTo: 'edge', // 标签对齐方式，edge表示对齐到饼图边缘
          formatter: "{b}\n{c}({d}%)", // 标签格式化器：{b}=数据名, {c}=数值, {d}=百分比，使用\n换行
          minMargin: 10, // 标签与饼图边缘的最小间距
          edgeDistance: 20, // 标签距离边缘的距离
          lineHeight: 18, // 标签行高，多行文本时的行间距
        },
        // 图例配置（说明每种颜色代表什么）
        legend: {
          orient: 'vertical', // 图例排列方向，vertical=垂直排列
          left: 'right' // 图例位置，右侧对齐
        },
        // 提示框配置（鼠标悬停时显示的提示信息）
        tooltip: {
          trigger: "item", // 触发类型，item表示单个数据项触发
          formatter: "{b} : {c} ({d}%)" // 提示框内容格式：名称 : 数值 (百分比)
        },
        // 系列列表（定义图表的数据和样式）
        series: [
          {
            // 颜色配置，定义饼图各块的颜色
            color:['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc'],
            // 数据数组，每个对象包含value（数值）和name（名称）
            data: [
              // { value: 1048, name: '已收'},
              // { value: 735, name: '待收'},
            ],
            // 高亮样式配置（鼠标悬停时的效果）
            emphasis: {
              label: {
                show: true, // 显示标签
                fontSize: 16, // 字体大小
                fontWeight: 'bold' // 字体粗细
              }
            },
            type: "pie", // 图表类型，pie表示饼图
            radius: ['40%','70%'], // 饼图半径，内圆40%，外圆70%，形成环形图效果
            avoidLabelOverlap: true, // 是否防止标签重叠，自动调整标签位置
            // 扇形样式配置
            itemStyle: {
              borderColor: '#fff', // 边框颜色，白色
              borderWidth: 2, // 边框宽度
              borderRadius: 10, // 圆角半径，使扇形边缘圆润
            }
          },
        ],
      });
    },
  },
};
</script>

<style lang="less" scoped>
</style>
